import { EntityRepository, Repository } from "typeorm";
import { WorkerEntity } from "./workers.entity";

@EntityRepository(WorkerEntity)
export class WorkersRepository extends Repository<WorkerEntity> {
  
}


